module.exports = __webpack_public_path__ + "img/EN_B.5d03e7ea.png";